import { render, staticRenderFns } from "./ProjectTemplateRow.vue?vue&type=template&id=240dd516&"
import script from "./ProjectTemplateRow.vue?vue&type=script&lang=js&"
export * from "./ProjectTemplateRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports